module.exports = __webpack_public_path__ + "img/venom.de90e3c6.svg";